const request = {
    invalid_input: 'Input is invalid. {{details}}',
    general: 'Request error occurred.',
    range_not_satisfiable: 'Range not satisfiable.',
};
export default Object.freeze(request);
